import React from "react"
import { css } from "@emotion/css"

export const Unauthorized = () => {
  return <div className={root}>{"🚫"}</div>
}

const root = css`
  height: 100%;
  display: flex;
  font-size: 4rem;
  align-items: center;
  justify-content: center;
  color: var(--red);
`
